import styled from "styled-components";

interface NewFlagProps {
    type: 'product' | 'building' | 'tech-sector-city' | 'tech-sector-building';
    animationDelay?: number;
}

const NewFlag = styled.div<NewFlagProps>`
    position: absolute;
    display: inline-block;
    top: 22px;
    left: 50%;
    transform: translateX(-50%);
    background: ${(props) => props.theme.colors.secondary};
    text-transform: uppercase;
    padding: 4px 3px 10px;
    font-size: 12px;

    ${(props) =>
        props.type === 'building'
            ? `
        top: 22px;
        padding: 14px 6px 4px;
        color: #fff;
        font-size: 10px;
    `: ''};

    ${(props) =>
        props.type === 'tech-sector-city'
            ? `
        top: -20px;
        padding: 2px 1px;
        padding-bottom: 20px;
        z-index: -1;
        font-size: 9px;
        clip-path: polygon(0 0,100% 0,100% 100%,88% 83%,75% 73%,56% 68%,42% 68%,25% 75%,12% 86%,0 100%);
    `: ''};

    ${(props) =>
        props.type === 'tech-sector-building'
            ? `
            @keyframes fadeIn {
                0% { opacity: 0; }
                100% { opacity: 1; }
            }
            animation: fadeIn 0.2s ease-out forwards;
            animation-delay: ${ '1.' + (props.animationDelay ?? 0 + 2) + 's'};
            opacity: 0;
    `:''};

    @media ${(props) => props.theme.screens.lg} {
        top: -37px;
        padding: 8px 5px 20px;
        font-size: 18px;

        ${(props) =>
            props.type === 'building'
                ? `
        top: 37px;
        padding: 20px 9px 6px;
        color: #fff;
        font-size: 15px
        `
                : ''};
    }
`;

export default NewFlag;